import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=1d5b06e6&scoped=true"
import script from "./FavoritesList.vue?vue&type=script&lang=js"
export * from "./FavoritesList.vue?vue&type=script&lang=js"
import style0 from "./FavoritesList.vue?vue&type=style&index=0&id=1d5b06e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b06e6",
  null
  
)

export default component.exports